import { Navigate } from "react-router";
import useChatbotConfig from "../hooks/useChatbotConfig";

const PublicRouter = ({ children }) => {
  const { log } = useChatbotConfig();

  return !log ? children : <Navigate to="/home" />;
};

export default PublicRouter;
